import { Routes } from '@angular/router';
import { LoginComponent, LoginTestComponent } from './login/components';
import { MenuComponent, OopsComponent } from './shared/components';
import { InvitationExpiredComponent, RegistrationComponent } from './registration/components';
import { SsoComponent } from './login/components/sso/sso.component';

export const routes: Routes = [
    {
        path: '',
        component: MenuComponent,
        pathMatch: 'full',
        title: 'Profile client'
    },
    {
        path: 'test-sso',
        component: SsoComponent,
        title: 'Test SSO Connection'
    },
    {
        path: 'login',
        component: LoginComponent,
        title: 'Test Password Connection'
    },
    {
        path: 'login/test',
        component: LoginTestComponent,
        title: 'Test Password Connection (Popup)'
    },
    {
        path: 'oops',
        component: OopsComponent
    },
    {
        path: 'register',
        component: RegistrationComponent,
        title: 'Register to Bannerflow'
    },
    {
        path: 'invitation-expired',
        component: InvitationExpiredComponent
    }
];
